import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-ux-design-services',
  templateUrl: './ui-ux-design-services.component.html',
  styleUrls: ['./ui-ux-design-services.component.css']
})
export class UiUxDesignServicesComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/ui-ux-design-services/ui-ux-design-services.component.ts